import { BaseModel } from "../shared/base.model";

export class Country extends BaseModel {

    private _num_code: number = -1;
    private _alpha_2_code: string = "";
    private _alpha_3_code: string = "";
    private _en_short_name: string = "";
    private _nationality: string = "";

    public get num_code(): number {
        return this._num_code;
    }

    public set num_code(value: number) {
        this._num_code = value;
    }

    public get alpha_2_code(): string {
        return this._alpha_2_code;
    }

    public set alpha_2_code(value: string) {
        this._alpha_2_code = value;
    }

    public get alpha_3_code(): string {
        return this._alpha_3_code;
    }

    public set alpha_3_code(value: string) {
        this._alpha_3_code = value;
    }

    public get en_short_name(): string {
        return this._en_short_name;
    }

    public set en_short_name(value: string) {
        this._en_short_name = value;
    }

    public get nationality(): string {
        return this._nationality;
    }

    public set nationality(value: string) {
        this._nationality = value;
    }

    public static toCountries(obj: string | Object[]): Country[] {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let droneModel: Country[] = [];

        for (const o2 of (<Object[]>obj2)) {
            droneModel.push(Country.toCountry(o2));
        }

        return droneModel;
    }

    public static toCountry(obj: string | Object): Country {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of DroneModel.
        return Object.assign(new Country(), obj2);
    }
}    
